<template>
  <Head title="Votre Espace" />
  <template v-if="isHijacked">
    <hijack-bar />
    <div class="h-6" />
  </template>
  <slot />
</template>

<script setup lang="ts">
import HijackBar from '@/components/HijackBar.vue'
import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'

const isHijacked = computed(() => usePage().props.impersonation_active || false)
</script>
